import { Admin } from "@/models/admin";
import { TicketMessageAttachement } from "@/models/ticket-message-attachement";
import { TicketMessageAttention } from "@/models/ticket-message-attention";
import { User } from "@/models/user";
import { AuthService } from "@/services/auth-service";
import { AuthSocketService } from "@/services/auth-socket-service";
import { Ticket } from "./ticket";
import { TicketMessageLike } from "./ticket-message-like";

export class TicketMessage {
	id:number;
	userId:number;
	adminId:number;
	ticketId:number;
	isInternal:boolean;
	isInterraction:boolean;
	content:string;
	timeCreated:Date;
	admin?:Admin;
	user?:User;
	attachements:TicketMessageAttachement[] = [];
	attentions:TicketMessageAttention[] = [];
	likes:TicketMessageLike[] = [];
	ticket:Ticket | null = null;

	constructor(data:any) {
		this.id = data.id;
		this.userId = data.userId;
		this.adminId = data.adminId;
		this.isInternal = data.isInternal;
		this.isInterraction = data.isInterraction;
		this.content = data.content;
		this.ticketId = data.ticketId;
		this.timeCreated = new Date(data.timeCreated);
		if (data.admin) {
			this.admin = new Admin(data.admin);
		}
		if (data.user) {
			this.user = new User(data.user);
		}
		if (data.attachements) {
			for (let attachement of data.attachements) {
				this.attachements.push(new TicketMessageAttachement(attachement));
			}
		}
		if (data.attentions) {
			for (let attention of data.attentions) {
				this.attentions.push(new TicketMessageAttention(attention));
			}
		}
		if (data.likes) {
			this.likes = data.likes.map((l:any)=>new TicketMessageLike(l));
		}
		if (data.ticket) {
			this.ticket = new Ticket(data.ticket);
		}
	}

	registerSocketEvents() {
		this.deregisterSocketEvents();
		AuthSocketService.on(`/tickets/message/${this.id}/update`, (data:any) => {
			this.userId = data.userId;
			this.adminId = data.adminId;
			this.isInternal = data.isInternal;
			this.isInterraction = data.isInterraction;
			this.content = data.content;
			this.ticketId = data.ticketId;
		}, this);
		AuthSocketService.on(`/tickets/message/${this.id}/attachement`, (data:any) => {
			this.attachements.push(new TicketMessageAttachement(data));
		}, this);
		AuthSocketService.on(`/tickets/message/${this.id}/attention`, (data:any) => {
			this.attentions.push(new TicketMessageAttention(data));
		}, this);
		AuthSocketService.on(`/tickets/message/${this.id}/like`, (data:any)=>{
			let like = new TicketMessageLike(data);
			if (this.adminHasLiked(like.adminId)) {
				return;
			}
			this.likes.push(like);
		}, this);
		AuthSocketService.on(`/tickets/message/${this.id}/un-like`, (adminId:number)=>{
			for (let i = this.likes.length-1; i>=0;i--){
				if (this.likes[i].adminId==adminId){
					this.likes.splice(i, 1);
				}
			}
		});
	}

	deregisterSocketEvents() {
		AuthSocketService.offAll(this);
	}

	getProfileImageUrl():string {
		if (!this.admin) {
			return "";
		}
		return this.admin.imageUrl;
	}

	getFirstName():string {
		if (this.admin && this.adminId != 0) {
			return this.admin.name.split(" ")[0];
		}
		if (this.user && this.userId != 0) {
			return `${this.user.firstname} ${this.user.lastname}`;
		}
		return "Winfakt Admin Systeem";
	}

	getUserName():string {
		if (this.admin && this.adminId != 0) {
			return this.admin.name;
		}
		if (this.user && this.userId != 0) {
			return `${this.user.firstname} ${this.user.lastname}`;
		}
		return "Winfakt Admin Systeem";
	}

	adminHasLiked(userId:number):boolean{
		for (let like of this.likes){
			if (like.adminId == userId) {
				return true;
			}
		}
		return false;
	}

	isLiked():boolean {
		if (!AuthService.user) return false;
		return this.adminHasLiked(AuthService.user.id);
	}
}